import { parsePhoneNumber, CountryCode } from 'libphonenumber-js/min';

export const formatPhoneNumber = (
  phoneText: string,
  countryCode?: CountryCode
) => {
  if (!phoneText) {
    return '';
  }

  try {
    const number = parsePhoneNumber(phoneText);

    return number.formatInternational();
  } catch (error) {
    if (error instanceof Error) {
      if (error.message === 'INVALID_COUNTRY' && countryCode) {
        const number = parsePhoneNumber(phoneText, countryCode);
        return number.isPossible() ? number.formatNational() : phoneText;
      }
      return phoneText;
    }
    return phoneText;
  }
};

export const extractDial = (rawPhone: string) => {
  if (!rawPhone) {
    return { dial: '', number: '' };
  }

  try {
    const phone = parsePhoneNumber(rawPhone);
    const dial = `+${phone.countryCallingCode}`;
    return { dial, number: rawPhone.replace(dial, '') };
  } catch (error) {
    return { dial: '', number: rawPhone };
  }
};
